import type {ReactElement} from 'react';
import type {IconWithTooltipProps} from './icon-with-tooltip.types';
import {TooltipPlacement} from './icon-with-tooltip.types';
import {deriveArrowPositionFromPlacement, getTooltipOverlayClassName} from './icon-with-tooltip-helper';
import styles from './icon-with-tooltip.module.scss';
import {Icon} from '@Components/icon-v2';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export function IconWithTooltip({arrowPosition, tooltipText, tooltipContent, hideArrow = false, placement = TooltipPlacement.TOP, ...props}: IconWithTooltipProps): ReactElement {
  const resolvedArrowPosition = arrowPosition ?? deriveArrowPositionFromPlacement(placement);
  const tooltipClassName = `${getTooltipOverlayClassName(hideArrow, resolvedArrowPosition)} ${styles.tooltip}`;
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      overlay={<Tooltip className={tooltipClassName}>{tooltipContent ?? tooltipText}</Tooltip>}
      delay={{show: 0, hide: props.toolTipHideDelay ?? 0}}
      placement={placement}
      offset={props.offset ? [props.offset.x, props.offset.y] : undefined}
    >
      <Icon {...props} className={props.className} />
    </OverlayTrigger>
  );
}

